import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as discoverService from '../services/discoverService';
import type {
  SearchProfilesParams,
  ExpressInterestParams,
  BrowseProfileParams,
  MyInterestsParams,
} from '../services/discoverService';

/**
 * Phase 3.3: Interactive Search/Browse Hooks
 */

const DISCOVER_KEY = ['discover'];

export const useSearchProfiles = (params: SearchProfilesParams) =>
  useQuery({
    queryKey: [...DISCOVER_KEY, 'search', params],
    queryFn: () => discoverService.searchProfiles(params),
    staleTime: 2 * 60 * 1000, // 2 minutes
  });

export const useExpressInterest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: ExpressInterestParams) =>
      discoverService.expressInterest(params),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...DISCOVER_KEY, 'search'] });
      qc.invalidateQueries({ queryKey: [...DISCOVER_KEY, 'interests'] });
    },
  });
};

export const useRecordBrowse = () => {
  return useMutation({
    mutationFn: (params: BrowseProfileParams) =>
      discoverService.recordBrowse(params),
  });
};

export const useMyInterests = (params: MyInterestsParams) =>
  useQuery({
    queryKey: [...DISCOVER_KEY, 'interests', params],
    queryFn: () => discoverService.getMyInterests(params),
  });
